import React from "react"
import { ExternalLink } from "lucide-react"

// Keep in sync with package.json — CRA can't import files outside src/
const APP_VERSION = "2.0.0"

const Footer = () => (
  <footer className="footer">
    <div className="footer__inner">
      <p className="footer__copy">
        &copy; {new Date().getFullYear()}{" "}
        <span className="footer__brand">Veeper</span>
        <span className="footer__suffix"> · Admin Panel</span>
      </p>
      <div className="footer__meta">
        <span className="footer__version" title="Admin panel version">
          v{APP_VERSION}
        </span>
        <span className="footer__credit">
          Crafted by{" "}
          <a
            href="https://reallifeapps.com"
            target="_blank"
            rel="noopener noreferrer"
            className="footer__link"
          >
            Real Life Apps
            <ExternalLink size={12} strokeWidth={2.2} aria-hidden="true" />
            <span className="visually-hidden"> (opens in a new tab)</span>
          </a>
        </span>
      </div>
    </div>
  </footer>
)

export default Footer
